import { render, staticRenderFns } from "./RidersSlider.vue?vue&type=template&id=da147a78&lang=pug&"
import script from "./RidersSlider.vue?vue&type=script&lang=js&"
export * from "./RidersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports